import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

export const SalesProofImage = ({ proof, testId, className }) => {
  const [unavailable, setUnavailable] = useState(false);

  if (unavailable) {
    return (
      <span className="flex h-full min-h-40 flex-col items-center justify-center gap-3 text-gray-600" role="status" data-testid={`${testId}-unavailable`}>
        <ImageOff size={28} aria-hidden="true" />
        <span>Screenshot temporarily unavailable</span>
      </span>
    );
  }

  return (
    <img
      src={proof.image_url}
      alt={proof.title}
      loading="lazy"
      decoding="async"
      onError={() => setUnavailable(true)}
      className={className}
      data-testid={testId}
    />
  );
};